
import Vue from 'vue';
import { mapGetters } from 'vuex';
import CreateAddressForm from '../components/CreateAddressForm.vue';
import { ACTIONS } from '../constants/actions';
import { GETTERS } from '../constants/getters';
import { APP_VUEX_MODULES } from '../constants/vuex-modules';
import { CreateAddressDto } from '../interfaces/addresses/address.interface';
export default Vue.extend({
  components: { CreateAddressForm },
  name: 'CreateAddress',
  computed: {
    ...mapGetters(APP_VUEX_MODULES.addresses, {
      isSubmitting: GETTERS.address.isSubmitting
    }),
    ...mapGetters(APP_VUEX_MODULES.bookings, {
      bookingPage: GETTERS.bookings.getSelectedBookingPage
    })
  },
  methods: {
    formSubmitHandler(data: CreateAddressDto): void {
      const bookingPageId = this.bookingPage.id;
      const { dispatch } = this.$store;
      dispatch(ACTIONS.address.create, { bookingPageId, data });
    }
  }
});
